import * as AppConstants from 'app/AppConstants';
import pickBy from 'lodash/pickBy';

const initialState = () => ({
  usersAndGroups: [],
  cards: [],
  pages: [],
  buzz: [],
  buzzChannels: [],
  facets: [],
  totalResults: null,
  numberOfResults: {},
  entity: null,
  currentFacet: null,
  query: '',
  recent: [],
  filters: {},
  entityFilters: {},
  isFilterOpen: false,
  queryUuid: null,
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.SEARCH__QUERY_STARTED:
      return {...state, query: action.payload.query};
    case AppConstants.SEARCH__QUERY_FINISHED: {
      const {
        cards,
        pages,
        usersAndGroups,
        buzz,
        buzzChannels,
        facets,
        totalResults,
        numberOfResults,
        queryUuid,
      } = action.payload;
      return {
        ...state,
        cards,
        pages,
        usersAndGroups,
        buzz,
        buzzChannels,
        facets,
        totalResults,
        numberOfResults,
        queryUuid,
      };
    }
    case AppConstants.SEARCH__EXECUTED_SEARCH_USERS_AND_GROUPS:
      return {...state, usersAndGroups: action.payload};
    case AppConstants.SEARCH__EXECUTED_SEARCH_CARDS:
      return {...state, cards: action.payload};
    case AppConstants.SEARCH__EXECUTED_SEARCH_PAGES:
      return {...state, pages: action.payload};
    case AppConstants.SEARCH__EXECUTED_SEARCH_DOMOBUZZ:
      return {...state, buzz: action.payload.searchResults};
    case AppConstants.SEARCH__SELECTED_SEARCH_RESULT:
      return {...state, recent: action.payload.recent};
    case AppConstants.SEARCH__SET_RECENT:
      return {...state, recent: action.payload.recent};
    case AppConstants.SEARCH__RESET_SEARCH:
      return {...initialState(), recent: action.payload.recent};
    case AppConstants.SEARCH__ENTITY_SET:
      return {
        ...state,
        entity: action.payload.entity,
        entityFilters: {...state.entityFilters, ...action.payload.entityFilter},
      };
    case AppConstants.SEARCH__ENTITY_CLEARED:
      return {...state, entity: null, entityFilters: {}};
    case AppConstants.SEARCH__CURRENT_FACET_SET:
      return {...state, currentFacet: action.payload.facet};
    case AppConstants.SEARCH__CURRENT_FACET_CLEARED:
      return {...state, currentFacet: null};
    case AppConstants.SEARCH__FILTER_ADDED:
      return {
        ...state,
        currentFacet: null,
        filters: {...state.filters, ...action.payload.filter},
      };
    case AppConstants.SEARCH__FILTERS_CLEARED:
      return {...state, entity: null, filters: {}, entityFilters: {}};
    case AppConstants.SEARCH__FILTER_CLEARED: {
      const filters = pickBy(
        state.filters,
        (value, key) => key !== action.payload.facet
      );
      return {...state, filters};
    }
    case AppConstants.SEARCH__FILTER_OPEN_TOGGLED:
      return {...state, isFilterOpen: !state.isFilterOpen};

    default:
      return state;
  }
};
